import React from 'react';
import './SpotifyCard.css';

export default function SpotifyCard(props) {
    const src = props.spotifyEmbedUrl || (props.spotifyId ? `https://open.spotify.com/embed-podcast/episode/${props.spotifyId}` : null);

    if (!src) {
        return null;
    }

    return (
        <div className="spotifyCard">
            <iframe src={src}
                width="70%"
                height="232"
                frameBorder="0"
                allowtransparency="true"
                allow="encrypted-media"
                title={props.title} />
        </div>
    );
}
